<template>
<!-- contents -->
<div id="contents">
    <div class="contents_wrap">
        <!-- contents_head -->
        <!-- breadcrumbs -->
        <skp-breadcrumbs @page-title="val => pageTitle = val" />
        <!-- //breadcrumbs -->
        <h2 class="pg_title">{{ pageTitle }}</h2>
        <!-- //contents_head -->
        <div class="view_cont" v-if="!isLoading">
            <div class="view_info">
                <div class="view_category" v-if="typeof detail.PRD_CATEGORY_NM1 !== 'undefined'">
                    {{ detail.PRD_CATEGORY_NM1 }}
                    <em v-if="typeof detail.PRD_CATEGORY_NM2 !== 'undefined'">&gt;</em> {{ detail.PRD_CATEGORY_NM2 }}
                    <em v-if="typeof detail.PRD_CATEGORY_NM3 !== 'undefined'">&gt;</em> {{ detail.PRD_CATEGORY_NM3 }}
                </div>
                <div class="icoBtn_wrap">
                    <a href="javascript:" class="ico_linkcopy" @click="urlCopy">
                        <span class="sr_only">Link Copy</span>
                        <input  type="hidden"
                                name="knowledgeUrl"
                                id="knowledgeUrl"
                                :value="'/basis/knowledge/knowledgeDetail?KNOWLEDGE_ID=' + detail.KNOWLEDGE_ID + '&boradId=' + detail.BOARD_ID">
                    </a>
                    <a href="javascript:" class="ico_printer" @click="printContents(detail.KNOWLEDGE_ID)">
                        <span class="sr_only">{{ $t('BUTTON.GLOBAL.PRINT') }}</span>
                    </a>
                    <a href="javascript:"
                        class="ico_favorite"
                        :class="isFavorite ? '' : 'off'"
                        @click="clickFavorite($event)"
                    >
                        <span class="sr_only">{{ $t('BUTTON.GLOBAL.FAVORITE') }}</span>
                    </a>
                </div>
            </div>
            <dl class="view_subject">
                <dt class="subject">
                    <em v-if="detail.IMPORTANCE_YN === 'Y'" class="textcolor_important">[{{ $t('FIELD.GLOBAL.IMPORTANT') }}]</em>
                    <em v-else-if="detail.MUST_READ_YN === 'Y'" class="textcolor_must">[{{ $t('FIELD.GLOBAL.MUSTREAD') }}]</em>
                    {{ detail.KNOWLEDGE_TITLE | refTitle | decodeXSS }}
                </dt>
                <dd class="desc">
                    <span class="desc_Regist">
                        <em>{{ $t('FIELD.GLOBAL.REGISTERED.BY') }}</em>
                        {{ detail.REG_USER }} ({{ detail.REG_DT }})
                    </span>
                    <span class="desc_modify">
                        <em>{{ $t('FIELD.GLOBAL.MODIFY.USER') }}</em>
                        {{ detail.MODF_USER }} ({{ detail.MODF_DT }})
                    </span>
                </dd>
            </dl>

            <!-- tab -->
            <div class="view_desc">
                <!-- 200420수정 S -->
                <!-- SCMS Contents 의 경우, Symptom 및 Serial 등 추가 항목 -->
                <table v-if="isSCMS" class="data_table_ty2 mb-20">
                    <colgroup>
                        <col width="20%">
                        <col width="30%">
                        <col width="20%">
                        <col width="*">
                    </colgroup>
                    <tbody>
                        <tr>
                            <th class="text_left">{{ $t('FIELD.GLOBAL.SYMPTOM') }}</th>
                            <td colspan="3">
                                <ul class="in_dotlist" v-if="symptomList.length === 0">
                                    <li>&nbsp;</li>
                                </ul>
                                <ul class="in_dotlist" v-else v-for="symptom in symptomList">
                                    <li>{{ symptom.C_CODE_T_INFO }} > {{ symptom.CODE_T_INFO }}</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <th class="text_left">{{ $t('FIELD.KNOWLEDGE.MANUFACTURE') }}</th>
                            <td>
                                <ul class="in_dotlist">
                                    <li v-if="typeof(detail.MANUFACTURE_S_DT) !== 'undefined'">
                                        {{ (detail.MANUFACTURE_S_DT + '01') | dateFormat('MMM.YYYY') }} ~ {{ (detail.MANUFACTURE_E_DT + '01') | dateFormat('MMM.YYYY') }}
                                    </li>
                                </ul>
                            </td>
                            <th class="text_left">{{ $t('FIELD.QNA.SERIAL.NUMBER') }}</th>
                            <td>
                                <ul class="in_dotlist" v-if="serialList.length === 0">
                                    <li>&nbsp;</li>
                                </ul>
                                <ul class="in_dotlist" v-else v-for="serial in serialList">
                                    <li>{{ serial.SERIAL_S }} ~ {{ serial.SERIAL_E}}</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <th class="text_left">{{ $t('FIELD.KNOWLEDGE.GUIDETYPE') }}</th>
                            <td>{{ getGuideTypeName }}</td>
                            <th class="text_left">{{ $t('FIELD.KNOWLEDGE.DEFECTTYPE') }}</th>
                            <td>{{ getDefectTypeName }}</td>
                        </tr>
                    </tbody>
                </table>
                <!-- //200420수정 E -->

                <div class="tab_wrap">
                    <ul class="tab_menu_02 tab_menus">
                        <li class="on" @click="changeTab($event)"><a href="javascript:">{{ $t('FIELD.GLOBAL.DESCRIPTION') }}</a></li>
                        <li @click="changeTab($event)"><a href="javascript:">{{ $t('FIELD.GLOBAL.MODEL.LIST') }}</a></li>
                        <li @click="changeTab($event)"><a href="javascript:">{{ $t('FIELD.KNOWLEDGE.PARTSLISTS') }}</a></li>
                        <li @click="changeTab($event)"><a href="javascript:">{{ $t('FIELD.KNOWLEDGE.VERHISTORY') }}</a></li>
                    </ul>
                    <div class="tab_contents">
                        <div class="tab_cont" v-html="detail.KNOWLEDGE_DESC" />
                        <div class="tab_cont" v-resize="setGridResizeColumn">
                            <model-grid
                                v-if="reloadModel"
                                :gridId="modelGridId"
                                :ref="modelGridId"
                                :data="modelList"
                                :columns="modelColumns"
                                :options="options"
                                :pageOptions="pageOptions"
                                :isTotalCount="true"
                                :click="popupBomOpen"
                            />
                        </div>
                        <div class="tab_cont" v-resize="setGridResizeColumn">
                            <parts-grid
                                v-if="reloadParts"
                                :gridId="partsGridId"
                                :ref="partsGridId"
                                :data="partsList"
                                :columns="partsColumns"
                                :options="options"
                                :pageOptions="pageOptions"
                                :isTotalCount="true"
                            />
                        </div>
                        <div class="tab_cont">
                            <!-- Version Tab -->
                            <table class="data_table">
                                <colgroup>
                                    <col width="15%">
                                    <col width="15%" class="pc_only">
                                    <col width="25%" class="pc_only">
                                    <col width="*">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>{{ $t('FIELD.GLOBAL.VERSION') }}</th>
                                        <th class="pc_only">{{ $t('FIELD.GLOBAL.DATE') }}</th>
                                        <th class="pc_only">{{ $t('FIELD.GLOBAL.EDITOR') }}</th>
                                        <th>{{ $t('FIELD.GLOBAL.DETAILS') }}</th>
                                    </tr>
                                </thead>
                                <tbody class="text_center">
                                    <tr v-if="versionList.length > 0" v-for="(version, idx) in versionList">
                                        <td>Ver.{{ version.VERSION_NO }}</td>
                                        <td class="pc_only">{{ version.MODF_DT }}</td>
                                        <td class="pc_only">{{ version.MODF_USER }}</td>
                                        <td class="text_left">
                                            <a  v-if="idx > 0"
                                                href="javascript:"
                                                class="over_line"
                                                @click="seeDetailPop(version.KNOWLEDGE_ID, version.VERSION_NO)"
                                            >
                                                {{ version.MODF_REASON }}
                                            </a>
                                            <template v-else>{{ version.MODF_REASON }}</template>
                                            <a  v-if="typeof(version.APPROVAL_ID) !== 'undefined'"
                                                href="javascript:"
                                                class="txt_link"
                                                @click="seeApprovalHistoryPop(version.APPROVAL_ID)"
                                            >
                                                {{ $t('FIELD.GLOBAL.ETC.001') }}
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div v-if="isPrevious" class="btn_wrap text_right pt-10">
                                <a href="javascript:" class="txt_link" :title="$t('FIELD.KNOWLEDGE.SEE.PREVIOUS')" @click="seePrevPop">{{ $t('FIELD.KNOWLEDGE.SEE.PREVIOUS') }}</a>
                            </div>

                        </div>
                    </div>
                </div>

                <!-- Attachment -->
                <div v-if="erpAllBoardIds.includes(boardId)" > <!-- Repair Guide or Repairability Score -->
                    <div v-if="attach1.length > 0" class="attachment_item">
                        <p v-if="erpEUBoardIds.includes(boardId)" class="attachment_title">{{$t('SUBTITLE.EUR.REAPIR.GUIDE1')}}</p>
                        <p v-if="erpERBoardIds.includes(boardId)" class="attachment_title">{{$t('SUBTITLE.EUR.REPRBLITY.SCORE')}} (Score)</p>
                        <innorix-download
                            v-if="attach1.length > 0 && erpAttchCnt > 0"
                            :uploadId="uploadId1"
                            :serviceType="serviceType"
                            :attachList="attach1"
                            :seq="getKnowledgeId"
                        />
                    </div>
                    <div v-if="attach2.length > 0" class="attachment_item">
                        <p v-if="erpEUBoardIds.includes(boardId)" class="attachment_title">{{$t('SUBTITLE.EUR.EXP.VIEW.PART.LIST')}}</p>
                        <p v-if="erpERBoardIds.includes(boardId)" class="attachment_title">{{$t('SUBTITLE.EUR.REPRBLITY.SCORE')}} (Calculation parameters)</p>
                        <innorix-download
                            v-if="attach2.length > 0 && erpAttchCnt > 1"
                            :uploadId="uploadId2"
                            :serviceType="serviceType"
                            :attachList="attach2"
                            :seq="getKnowledgeId"
                        />
                    </div>
                    <div v-if="attach3.length > 0" class="attachment_item">
                        <!-- <p v-if="erpEUBoardIds.includes(boardId)" class="attachment_title">{{$t('SUBTITLE.EUR.EXP.VIEW.PART.LIST')}}</p> -->
                        <p v-if="erpERBoardIds.includes(boardId)" class="attachment_title">{{$t('SUBTITLE.EUR.REPRBLITY.SCORE')}} (Admin)</p>
                        <innorix-download
                            v-if="attach3.length > 0 && erpAttchCnt > 2"
                            :uploadId="uploadId3"
                            :serviceType="serviceType"
                            :attachList="attach3"
                            :seq="getKnowledgeId"
                        />
                    </div>
                </div>
                <div v-else>
                    <innorix-download
                        v-if="attach.length > 0"
                        :uploadId="uploadId"
                        :serviceType="serviceType"
                        :attachList="attach"
                        :seq="getKnowledgeId"
                    />
                </div>

                <!-- //Attachment -->

                <!-- 3D Exploded View disabled
                <dl class="desc" v-if="attachTD.length > 0 && getSMMobileYn">
                    <em>* 3D Exploded View download</em>
                    <dd>
                        <ul>
                            <li v-for="file in attachTD" :key="file.ATTCH_FILE_SEQ">
                                <a href="javascript:" @click="popupHtmlOpen2(file)" class="txt_link">
                                    <span class="ico_attach"></span> {{ file.FILE_NM }}
                                </a>
                            </li>
                        </ul>
                    </dd>

                </dl>
                -->
                <br>

                <!-- 200622수정 S -->
                <dl class="attachment_link" v-if="attach.length > 0">
                    <dt><a href="javascript:" class="txt_link" @click="toggleLink($event)">Having trouble downloading?</a></dt>
                    <dd>
                        <ul>
                            <li v-for="file in attach" :key="file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN">
                                <a href="javascript:" @click="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)" class="txt_link">
                                    <span class="ico_attach"></span> {{ file.FILE_NM }}
                                </a>
                            </li>
                        </ul>
                    </dd>
                </dl>
            </div>
            <!-- 200622수정 E -->

            <div class="btn_wrap topLine">
                <a href="javascript:" class="btn_white size_full" :title="$t('BUTTON.GLOBAL.LIST')" @click="btnList">{{ $t('BUTTON.GLOBAL.LIST') }}</a>
                <div class="btn_right pc_only" v-if="btnAuth()">
                    <a href="javascript:" class="btn_white" :title="$t('BUTTON.GLOBAL.EXPIRE')" @click="btnExpire">{{ $t('BUTTON.GLOBAL.EXPIRE') }}</a>
                    <a href="javascript:" class="btn_white" :title="$t('BUTTON.GLOBAL.MODIFY')" @click="btnModify">{{ $t('BUTTON.GLOBAL.MODIFY') }}</a>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- contents -->
</template>
<script>
import Vue                                  from 'vue';
import { mapGetters }                       from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import axios                                from 'axios';
import qs                                   from 'query-string';
import resize                               from 'vue-resize-directive'

import store                                from '@/vuex/store';
import constants                            from '@/constants';
import SDLLocale                            from '@/mixin/SDLLocale';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

import CrossEditorViewer                    from '~c/CrossEditorViewer';
import InnorixDownload                      from '~c/InnorixDownload';
import SKPBreadcrumbs                       from '~vb/main/SKPBreadcrumbs';
import KnowledgeModelGrid                   from './popup/KnowledgeModelGrid';
import KnowledgePartsGrid                   from './popup/KnowledgePartsGrid';

import ApprovalHistoryPopup                 from '~c/popup/ApprovalHistoryPopup';
import KnowledgePreviousPopup               from './popup/KnowledgePreviousPopup';
import KnowledgeVersionDetailPopup          from './popup/KnowledgeVersionDetailPopup';
import KnowledgeContentsPrintPopup          from './popup/KnowledgeContentsPrintPopup';

const SCMS_CONTENTS_CD = MenuUtil.getScmsContents;

const fetchDetail = (knowledgeId, boardId) => axios.post(
    `${SDLUtil.API_URL}/basis/knowledge/knowledgeDetail.skp`,
    qs.stringify({ KNOWLEDGE_ID: knowledgeId, BOARD_ID: boardId }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

const fetchErpBoardIds = (menuDtlCd) => axios.post(
    `${SDLUtil.API_URL}/basis/eur/getBoardIdForErps.skp`,
    qs.stringify({ menuGrpDtlCd: menuDtlCd }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name : 'KnowledgeDetail',
    props : {
        knowledgeId: { type: null },
        boardId: { type: null },
        showRecommendPopup: { default: true }
    },
    data() {
        return {
            isLoading : true,
            pageTitle: '',
            window: { width: 0, height: 0 },

            erpAllBoardIds: [],
            erpEUBoardIds: [],
            erpERBoardIds: [],

            processStep: 0,
            modelList: [],
            modelColumnName: [],
            partsList: [],
            symptomList: [],
            serialList: [],
            satisfaction: [],
            attachImg: [],
            detail: {},
            attach: [],
            attach1: [],
            attach2: [],
            attach3: [],
            // 3D Exploded View disabled
            // attachTD: [],
            erpAttchCnt: 0,
            verifyList: [],
            versionList: [],
            isPrevious: false,
            isFavorite: false,
            isRepair: false,
            isSCMS: false,
            scmsYn: false,
            pUserId : '', 
            sModelCode : '',
            sCorpCode : '', 
            sCMD : '', 
            
            reloadModel: false,
            reloadParts: false,

            editorId: 'editor_' + String(this.knowledgeId),

            modelGridId: 'mdlGrid_' + String(this.knowledgeId),
            modelColumns: [],

            partsGridId: 'ptsGrid_' + String(this.knowledgeId),
            partsColumns: [],

            options: { scrollX: false, scrollY: true, minBodyHeight: 80, bodyHeight: 265 },
            pageOptions: { useClient: true, perPage: 20 },

            uploadId: 'download_' + String(this.knowledgeId),
            uploadId1: 'download_' + String(this.knowledgeId+1),
            uploadId2: 'download_' + String(this.knowledgeId+2),
            uploadId3: 'download_' + String(this.knowledgeId+3),
            serviceType: 'common'
        }
    },
    directives: { resize },
    computed: {
        ...mapGetters({
            userRoles: 'getRoles',
            userCorpCd: 'getCorpCd',
            params: 'getParams',
        }),
        getKnowledgeId() {
            return this.knowledgeId;
        },
        getBoardId() {
            return this.boardId;
        },
        getEditorId() {
            return this.editorId;
        },
        getBoardCreationYN() {
            return store.getters.getParams.creationYn || 'N';
        },
        getDefectTypeName() {
            let defectType = this.detail.DEFECT_TYPE || '',
                defectTypeName = { "M":"Common", "C":"Call", "R":"Repair" };

            if(!SDLUtil.isNull(defectType)) {
                return defectTypeName[defectType];
            } else {
                return  '-';
            }
        },
        getSMMobileYn() {
        	if (this.detail.PRD_CATEGORY_CD1 === 'D' && (this.detail.BOARD_TYPE1_NM === 'Service Manual' || this.detail.BOARD_TYPE2_NM === 'Service Manual' || this.detail.BOARD_TYPE3_NM === 'Service Manual')) {
                return true;
            }else{
        		return false;
        	}
        },
        getGuideTypeName() {
            let guideType = this.detail.GUIDE_TYPE || '',
//                 guideTypeName = {"H":"H/W", "S":"S/W", "M":"Mechanical", "A":"Accessory", "I":"Info Sharing", "E":"Others"};
            	//  C23030008966  서비스블레틴 신규 guide type 추가  ke01.liu 2023-04-07 begin 
                guideTypeName = {"P":"Parts Used", "S":"S/W & Firmware", "O":"On Site Check Guide", "R":"Repair Information & Tips", "A":"Alternative parts" , "M":"Manufacturing BOM Change"};

                //  C23030008966  서비스블레틴 신규 guide type 추가  ke01.liu 2023-04-07 end 
            if(!SDLUtil.isNull(guideType)) {
                return guideTypeName[guideType];
            } else {
                return  '-';
            }
        }
    },
    components: {
        'skp-breadcrumbs'   : SKPBreadcrumbs,
        'model-grid'        : KnowledgeModelGrid,
        'parts-grid'        : KnowledgePartsGrid,
        'cross-editor'      : CrossEditorViewer,
        'innorix-download'  : InnorixDownload
    },
    methods: {
        // initiation
        initLoad() {
            SDLUtil.showLoadingBar(true);
            return axios
                .post(
                    `${SDLUtil.API_URL}/basis/knowledge/knowledgeDetail.skp`,
                    qs.stringify({ KNOWLEDGE_ID: this.getKnowledgeId, mList: '', boardId: this.getBoardId }),
                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                )
                .then(res => {
                    return res.data;
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                    this.$router.go(-1);
                });
        },
        // 브라우저 리사이징 이벤트
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        urlCopy() {
            let inputUrl = document.createElement("input"),
                knowledgeUrl = document.URL;

            inputUrl.setAttribute("value", knowledgeUrl);
            document.body.appendChild(inputUrl);
            inputUrl.select();
            document.execCommand("copy");
            document.body.removeChild(inputUrl);

            const msg = SDLUtil.getMsgProp('MESSAGE.URL.COPIED');
            Vue.toasted.show( msg, { theme: "toasted-primary", position: "top-center", duration : 3000 } );
        },
        printContents(knowledgeId) {
            SDLUtil.show(
                KnowledgeContentsPrintPopup,
                {
                    KNOWLEDGE_ID: knowledgeId
                },
                { height: 'auto' }
            );
        },

        // 그리드 컬럼 percent resize 용
        getDynamicCols(type = '') {
            let colType = type;
            if(SDLUtil.isNull(type)) {
                if(this.processStep === 1) {
                    colType = 'MODEL';

                } else if(this.processStep === 2) {
                    colType = 'PARTS';
                };
            };

            if(SDLUtil.isMobile()) {
                if(colType === 'MODEL') {
                    let columns = 
                     [
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL.CODE'), name: 'CDMODEL', align: 'center', resizable: true, sortable: true,
                                    filter: { type: 'text', showApplyBtn: true, showClearBtn: true, state: { code: 'contain'} } },
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL'), name: 'NMMODEL', align: 'center', resizable: true, sortable: true },
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MARKETINGNAME'), name: 'MAKETNM', align: 'center', resizable: true, sortable: true },
                        { header: 'CDCOMPANY', name: 'CDCOMPANY', hidden: true },
                        { header: 'CDGBM', name: 'CDGBM', hidden: true },
                    ];

                    if (this.detail.PRD_CATEGORY_CD1 === 'D' && (this.detail.BOARD_TYPE1_NM === 'Service Manual' || this.detail.BOARD_TYPE2_NM === 'Service Manual' || this.detail.BOARD_TYPE3_NM === 'Service Manual')) {
                        columns.push({ header: SDLUtil.getMsgProp('FIELD.SEARCH.BOM'), name: 'BOM', align: 'center', resizable: true, sortable: false });
                    }

                    return columns;

                } else {
                    return [
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.PARTS.CODE'), name: 'PARTS_CODE', align: 'center', resizable: true, sortable: true },
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.PARTS.TYPE'), name: 'PARTS_TYPE', align: 'center', resizable: true, sortable: true }
                    ];
                }

            } else {
                if(colType === 'MODEL') {
                    // Service Manual flag: 4 cols with BOM, 3 cols without, evenly distributed
                    let isSvcManual = this.detail.PRD_CATEGORY_CD1 === 'D' && (this.detail.BOARD_TYPE1_NM === 'Service Manual' || this.detail.BOARD_TYPE2_NM === 'Service Manual' || this.detail.BOARD_TYPE3_NM === 'Service Manual');
                    let columns =
                    [
                        /* 2020.06.26 Subsidiary 컬럼 삭제 */
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL.CODE'), name: 'CDMODEL', align: 'center', width: this.getColumnSize(isSvcManual ? 25 : 34), resizable: true, sortable: true,
                                    filter: { type: 'text', showApplyBtn: true, showClearBtn: true, state: { code: 'contain'} } },
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL'), name: 'NMMODEL', align: 'center', width: this.getColumnSize(isSvcManual ? 25 : 33), resizable: true, sortable: true },
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MARKETINGNAME'), name: 'MAKETNM', align: 'center', width: this.getColumnSize(isSvcManual ? 25 : 33), resizable: true, sortable: true },
                        { header: 'CDCOMPANY', name: 'CDCOMPANY', hidden: true },
                        { header: 'CDGBM', name: 'CDGBM', hidden: true },
                    ];

                    if (isSvcManual) {
                        columns.push({ header: SDLUtil.getMsgProp('FIELD.SEARCH.BOM'), name: 'BOM', align: 'center', width: this.getColumnSize(25), resizable: true, sortable: false });
                    }

                    return columns;

                } else {
                    return [
                        /* 2020.04.06 Parts Name 컬럼 삭제 */
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.PARTS.CODE'), name: 'PARTS_CODE', align: 'center', width: this.getColumnSize(50), resizable: true, sortable: true },
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.PARTS.TYPE'), name: 'PARTS_TYPE', align: 'center', width: this.getColumnSize(50), resizable: true, sortable: true }
                    ];
                };
            };
        },
        getColumnSize(size) {
            if(isNaN(Number(size))) { return 0; }
            let gridWrapSize = document.getElementsByClassName('tab_cont').length ? document.getElementsByClassName('tab_cont')[this.processStep].clientWidth - 16 : 1000;
            // Removed extra -50 offset: outer -16 already compensates, so 100% fills the container
            return SDLUtil.isMobile() ? null : Math.floor(gridWrapSize / (100 / size));
        },
        setGridResizeColumn(e) {
            // 그리드 다이나믹 컬럼
            if(this.processStep === 1) {
                EventBus.$emit('model-grid-set-column', this.getDynamicCols('MODEL'));

            } else if(this.processStep === 2) {
                EventBus.$emit('parts-grid-set-column', this.getDynamicCols('PARTS'));
            };
        },

        // 버전 상세 보기 팝업
        seeDetailPop(knowledgeId, knowledgeVer) {
            Vue.$log.info("▶ KnowledgeDetailPopup.vue See Detail Popup => ", knowledgeId, knowledgeVer);
            SDLUtil.show(
                KnowledgeVersionDetailPopup,
                {
                    KNOWLEDGE_ID: knowledgeId,
                    VERSION_NO: knowledgeVer
                },
                { height: 'auto' }
            );
        },

        // 결재 이력 보기 팝업
        seeApprovalHistoryPop(approvalId) {
            Vue.$log.info("▶ KnowledgeDetailPopup.vue See Approval History Popup => ", approvalId);
            SDLUtil.show(
                ApprovalHistoryPopup,
                {
                    approvalId: approvalId
                },
                { height: 'auto' }
            );
        },

        // 복제 이전 버전 보기
        seePrevPop() {
            Vue.$log.info("▶ KnowledgeDetail.vue See Previous Popup");
            let prevId = this.detail['PREVIOUS_ID'] || '';
            if(!StringUtil.isNull(prevId)) {
                SDLUtil.show(
                    KnowledgePreviousPopup,
                    {
                        KNOWLEDGE_ID: prevId
                    },
                    { height: 'auto' }
                );
            };
        },

        // 즐겨찾기 버튼 클릭
        clickFavorite(e) {
            Vue.$log.info('▶ KnowledgeDetail.vue click favorite => ', this.isFavorite);
            let url = '', fvParams = { workCd: MenuUtil.getScrapWorkCode(), workCdSeq: this.getKnowledgeId };
            if( this.isFavorite ) {
                url = `${SDLUtil.API_URL}/basis/common/scrap/deleteScrap.skp`;
                this.isFavorite = false;
            } else {
                url = `${SDLUtil.API_URL}/basis/common/scrap/scrap.skp`;
                this.isFavorite = true;
            };

            return  axios.post( url, qs.stringify(fvParams), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } } )
                    .then(res => {
                        let msg = "";
                        if( this.isFavorite ) {
                            msg = SDLUtil.getMsgProp('MESSAGE.GLOBAL.ADDFAVORITE');
                        } else {
                            msg = SDLUtil.getMsgProp('MESSAGE.GLOBAL.REMOVEFAVORITE');
                        }
                        // Notification
                        Vue.toasted.show( msg, { theme: "toasted-primary", position: "top-center", duration : 3000 } );
                    })
                    .catch(err => {
                        SDLUtil.errorAlert(err);
                    });
        },
        changeTab(e) {
            let tabIndex = $('.tab_menus > li > a').index(e.target);
            this.processStep = tabIndex;

            if( $(e.target).hasClass('on') == true){
                $(e.target).parents('li').removeClass('on');
                $('.tab_wrap .tab_cont').hide();

            } else {
                $('.tab_wrap li').removeClass('on');
                $('.tab_wrap .tab_cont').hide();
                $(e.target).parents('li').addClass('on');
                $('.tab_wrap .tab_cont').eq(tabIndex).show();

                if(this.processStep === 1) {
                    this.reloadModel = true;
                    // Apply columns after nextTick: once grid is remounted, emit set-column to reflect real widths
                    this.$nextTick(() => {
                        EventBus.$emit('model-grid-set-column', this.getDynamicCols('MODEL'));
                        EventBus.$emit('model-grid-refresh');
                    });

                } else if(this.processStep === 2) {
                    this.reloadParts = true;
                    this.$nextTick(() => {
                        EventBus.$emit('parts-grid-set-column', this.getDynamicCols('PARTS'));
                        EventBus.$emit('parts-grid-refresh');
                    });

                } else {
                    this.reloadModel = false;
                    this.reloadParts = false;
                };
            };

            EventBus.$emit('grid-refresh');
        },
        btnList() {
            const sParams = SDLUtil.getBoardSearchParams(this.boardId);
            const params = {
                BOARD_ID: this.boardId,
                searchPRD_CATEGORY_CD1: sParams.searchParams.searchPRD_CATEGORY_CD1 || '',
                searchPRD_CATEGORY_CD2: sParams.searchParams.searchPRD_CATEGORY_CD2 || '',
                searchPRD_CATEGORY_CD3: sParams.searchParams.searchPRD_CATEGORY_CD3 || '',
                searchFromAddDt: sParams.searchParams.searchFromAddDt || '',
                searchToAddDt: sParams.searchParams.searchToAddDt || '',
                sb_guide_type: sParams.searchParams.sb_guide_type || '',
                sb_defect_type: sParams.searchParams.sb_defect_type || '',
                searchTitle: sParams.searchParams.searchTitle || '',
                selectedModel: sParams.searchParams.selectedModel || '',
                searchSYMPTOM_TYPE: sParams.searchParams.searchSYMPTOM_TYPE || '',
                searchSYMPTOM_TYPE1: sParams.searchParams.searchSYMPTOM_TYPE1 || '',
                multi: sParams.searchParams.multi || '',
                page: sParams.searchParams.page || 1,
                reSearch: 'Y'
            };

            return this.$router.push({ name: 'KnowledgeList', query: params });
        },
        btnAuth() {
            let isAuth = false;
            if(
                SDLUtil.isNull(this.detail.CTTID) &&
                this.userRoles.find(
                    r => r === `${constants.SYSTEM_ADMIN}`
                      || r === `${constants.GBM_ADMIN}`
                      || r === `${constants.RHQ_ADMIN}`
                      || r === `${constants.SUB_ADMIN}`
                      /*
                        /basis/knowledge/symptom/Detail.jsp line 541
                        Environment admin 권한에 대해서도 수정 할 수 있는 권한을 부여하자
                        ( 전제조건: Environment 환경 컨텐츠 국한되어야 하는데... ) SEA 의 경우 ROLE 2200 은 환경컨텐츠가 아님.
                      */
                      || ( r === `${constants.ENV_ADMIN}` && this.userCorpCd !== 'C310' )
                )
            ) {
                isAuth = true;
            }

            return isAuth;
        },
        btnExpire() {
            SDLUtil.showLoadingBar(true);
            SDLUtil.confirm({
                title: "TITLE.WARNING.TITLE",
                msg: 'MESSAGE.DATA.EXPIRE.CONFIRM',
                onOkEvt: () => {
                    return  axios.post(
                                `${SDLUtil.API_URL}/basis/myKnowledge/myKnowledge/register/expire.skp`,
                                qs.stringify({ KNOWLEDGE_ID: this.getKnowledgeId, boardTypeRoot: this.userCorpCd }),
                                { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                            )
                            .then(res => {
                                let data = res.data;
                                if(data.msg) {
                                    SDLUtil.alert({
                                        title: 'FIELD.GLOBAL.PROGRESS.COMPLETE',
                                        msg: _.replace(data.msg, /(\r?\\n)/g, '<br/>'),
                                        onOkEvt: () => {
                                            this.btnList();
                                        }
                                    });
                                }
                            })
                            .catch(err => {
                                SDLUtil.errorAlert(err);
                            });
                }
            });
            SDLUtil.showLoadingBar(false);
        },
        btnModify() {
            if(this.scmsYn) { return SDLUtil.alert('MESSAGE.KNOWLEDGE.CONTENTS.SCMS.ONLY'); };
            let KNOWLEDGE_ID = this.getKnowledgeId;
            Vue.$log.info('▶ KnowledgeDetail.vue modify event. =>', KNOWLEDGE_ID);

            store.commit('POPUP_PARAMS', { knowledgeId : KNOWLEDGE_ID, isModify: true });
            let linkUrl = MenuUtil.getRedirectUrl('/basis/myKnowledge/myKnowledge/register/registerForm');
            SDLUtil.openLegacyWindowPopup({
                url: linkUrl,
                title: SDLUtil.getMsgProp('TITLE.KNOWLEDGE.DETAIL'),
                w: 1366,
                h: 768
            });
        },
        getDownloadUrl(SEQ, TOKEN) {
            let cmnApiBase = `${SDLUtil.API_URL}/basis/common/attachDownload.skp`;
            return window.open(cmnApiBase + '?attachFileSeq=' + SEQ + '&encToken=' + TOKEN);
        },
        popupHtmlOpen(file) {
            console.log('url ==> ', 'http://downloadcenter.samsung.com/content/' + file.FILE_DIR + '?cmd='+this.sCMD+'&userId='+this.pUserId+'&model='+this.sModelCode+'&corpCode='+this.sCorpCode+'&sysname=W-GSPN');
        
            SDLUtil.openLegacyWindowPopup({
                url: 'http://downloadcenter.samsung.com/content/' + file.FILE_DIR + '?cmd='+this.sCMD+'&userId='+this.pUserId+'&model='+this.sModelCode+'&corpCode='+this.sCorpCode+'&sysname=W-GSPN',
                title: 'SAMSUNG.COM SUPPORTED',
                w: 1050,
                h: 820
            });
        },
        popupHtmlOpen2(file) {
			let fileEncTok = file.ENC_TOKEN;
			let fileSeq = file.ENC_ATTCH_FILE_SEQ;
        	let cmnApiBase = `${SDLUtil.API_URL}/basis/common/attachDownload.skp`;
        	//Because CONTENT_CLICK requires that version cannot be empty, a value is passed just to ensure that version is not null; this is solely for the purpose of avoiding an empty version, not for statistical purposes.
        	let version = file.WORK_CD;
        	let contentId = file.WORK_CD_SEQ1;
        	let bomVersion = file.WORK_CD;
            console.log('url ==> ', '...' + file.FILE_DIR + '?cmd='+this.sCMD+'&userId='+this.pUserId+'&model='+this.sModelCode+'&corpCode='+this.sCorpCode+'&sysname=W-GSPN');
        
            SDLUtil.openLegacyWindowPopup({
                url: ''+cmnApiBase + '?attachFileSeq='+fileSeq+'&encToken='+fileEncTok+'&model='+this.sModelCode+'&evGubun=TDS'+'&version='+version+'&contentId='+contentId+'&bomVersion='+bomVersion,
                title: 'SAMSUNG.COM SUPPORTED',
                w: 1050,
                h: 820
            });
        },
        toggleLink(e) {
            $('.attachment_link > dd').toggle();
        },
        popupBomOpen(e, rowData, grid) {

            if (this.detail.PRD_CATEGORY_CD1 !== 'D') {
                return false;
            }

            const url = `${SDLUtil.API_URL}/basis/search/redirectBomView.skp`;
            return axios
                .post(url, qs.stringify({ modelCode: rowData[e.rowKey].CDMODEL }), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' }
                })
                .then(resp => {
                    SDLUtil.openLegacyWindowPopup({
                        url: resp.data,
                        title: 'SAMSUNG.COM SUPPORTED',
                        w: 850,
                        h: 720
                    });
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                });
        },
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        this.initLoad().then(res => {
            Vue.$log.info("▶ KnowledgeDetail.vue Response => ", res);
            this.symptomList = res.symptomList.rowData;
            this.serialList = res.serialList.rowData;
            this.modelList = res.modelList.rowData;
            this.modelColumnName = res.modelList.columnName;
            this.partsList = res.partsList.rowData;
            this.satisfaction = res.satisfaction.rowData;
            this.attachImg = res.attachImg.rowData;
            this.detail = res.detail.rowData[0];
            if (this.erpAllBoardIds.includes(this.boardId)) { // 2020.11.05 김남갑 추가
                if (res.attach1) this.attach1 = res.attach1.rowData;
                if (res.attach2) this.attach2 = res.attach2.rowData;
                if (res.attach3) this.attach3 = res.attach3.rowData;
            } else {
                //this.attach = res.attach.rowData;

        		if (this.detail.PRD_CATEGORY_CD1 === 'D' && (this.detail.BOARD_TYPE1_NM === 'Service Manual' || this.detail.BOARD_TYPE2_NM === 'Service Manual' || this.detail.BOARD_TYPE3_NM === 'Service Manual')) {

            		// 3D Exploded View disabled
            		// this.attachTD = res.attachTD.rowData;
            		this.attach = res.attach.rowData;

            		this.pUserId = res.pUserId;
            		this.sModelCode = res.sModelCode;
            		this.sCorpCode = res.sCorpCode;
            		this.sCMD = res.sCMD;
                        console.log('this.pUserId => ', this.pUserId);
                        console.log('this.pUserId1 => ', this.pUserId[0]);

            	}
            	else {
                	this.attach = res.attach.rowData;
                }
            }
            this.verifyList = res.verifyList.rowData;
            this.versionList = res.version.rowData;
            
            for (const iterator of this.modelList) {
                if (!SDLUtil.isNull(iterator.MODEL_ID)) {
                    iterator.BOM = '<a href="JavaScript:" class="ico_attach"><span class="sr_only"></span></a>';
                }
            }

            this.scmsYn = StringUtil.strToBool(this.detail['SCMS_YN']);
            this.$nextTick(() => {
                /*
                 * RecommendPopup.vue 로 이벤트 전달 -> (param : knowledgeId)
                 * Footer 하단 markup 으로 인해 SKPMain.vue로 팝업을 위치, 이벤트를 전달 한다.
                 */
                if(this.showRecommendPopup) {
                    EventBus.$emit('knowledge-recommend-show', { knowledgeId: this.getKnowledgeId, scmsYn: StringUtil.strToBool(this.detail['SCMS_YN']) });
                };
            });

            this.modelColumns = this.getDynamicCols('MODEL');
            this.partsColumns = this.getDynamicCols('PARTS');

            // 즐겨찾기 확인
            try{
                if(this.detail['FAVORITE'] == 0) {
                    this.isFavorite = false;
                } else {
                    this.isFavorite = true;
                };

            } catch(e) {
                this.isFavorite = false;
            };

            // 이전 버전 존재 확인
            try {
                if(SDLUtil.isNull(this.detail['PREVIOUS_ID'])) {
                    this.isPrevious = false;
                } else {
                    this.isPrevious = true;
                };

            } catch(e) {
                this.isPrevious = false;
            }

            // SCMS 컨텐츠 확인
            let menuGroupDetailCd = this.detail['MENU_GROUP_DETAIL_CD'] || '';
            if( _.includes(SCMS_CONTENTS_CD, menuGroupDetailCd) ) {
                if(menuGroupDetailCd === 'RT') this.isRepair = true;
                this.isSCMS = true;
            };

            SDLUtil.showLoadingBar(false);
            this.isLoading = false;
        });
    },
    mounted() {
        // Mounted event
        // 2020.11.06 김남갑 추가
        fetchErpBoardIds().then(res => {
            res.data.forEach(board => {
                this.erpAllBoardIds.push(board.BOARD_ID);
            });
        }).catch( err => {
            SDLUtil.errorAlert(err);
        });

        // Repair Guide
        fetchErpBoardIds('EU').then(res => {
            res.data.forEach(board => {
                this.erpEUBoardIds.push(board.BOARD_ID);
            });
        }).catch( err => {
            SDLUtil.errorAlert(err);
        });

        // Repairability Scores
        fetchErpBoardIds('ER').then(res => {
            res.data.forEach(board => {
                this.erpERBoardIds.push(board.BOARD_ID);
            });
        }).catch( err => {
            SDLUtil.errorAlert(err);
        });

        this.$nextTick(() => {
            setTimeout(() => {
                this.erpAttchCnt++;
                setTimeout(() => {
                    this.erpAttchCnt++;
                    setTimeout(() => {
                        this.erpAttchCnt++;
                    }, 500);
                }, 500);
            }, 600);
        });
    },
    beforeDestroy() {
        Vue.$log.info('▶ KnowledgeDetail.vue beforeDestroy.');
        window.removeEventListener('resize', this.handleResize);
    },
};
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/knowledge/KnowledgeDetail.vue